/**
 * <x-clouds> — Declarative cloud configuration element.
 *
 *   <x-scene>
 *     <x-clouds comp="clouds.coverage=0.6; clouds.extinction=0.05;
 *                     clouds.bottom=1500; clouds.top=4000"></x-clouds>
 *   </x-scene>
 */

import { defineXElement, XBaseElement } from '../../../html/elements/defineXElement.js';

class XCloudsElement extends XBaseElement {}

export function defineXClouds(): void {
  defineXElement('x-clouds', XCloudsElement);
}
